// extracted by mini-css-extract-plugin
export default {"content":"ClassificationDialog_content__oLf6U"};